import { useState } from 'react'
// import downArrow from '../../../assets/images/downArrow.svg'
import check_mark from '../../../assets/images/icons/check_mark.svg'
import xmark from '../../../assets/images/icons/xmark.svg'
import downArrow from '../../../assets/images/icons/down-arrow.svg'
import upArrow from '../../../assets/images/icons/up-arrow.svg'
import ViewAll from '../ViewAll'

const CheckListLayout = ({ layout, value }) => {
  // const icon = require('../../../assets/images/tick.svg').default
  // console.log('>>>>VAlue', value.icon_name)
  const [seeAll, setseeAll] = useState(false)
  const showAll = () => {
    setseeAll(!seeAll)
  }
  return (
    <div
      style={{
        padding: '24px 20px 24px 20px',
        background: layout.color ? `#${layout.color}` : '',
        // background: '#f000f0',
      }}
    >
      <div
        style={{
          marginTop: '10px',
          marginBottom: '10px',
          textAlign: 'left',
          color: 'var(--gray100)',
          listStyle: 'none',
        }}
        className="title2"
      >
        <p>{layout.display_name}</p>
      </div>
      {value.map((item, index) => {
        if (index <= 4) {
          return (
            <div
              style={{
                display: 'flex',
                marginBottom: '-1rem',
                alignItems: 'baseline',

                margin: '24px 0px',
              }}
            >
              {item.icon_name === 'checkmark' && (
                <img
                  src={check_mark}
                  alt=""
                  style={{ marginRight: '14px' }}
                ></img>
              )}
              {item.icon_name === 'xmark' && (
                <img src={xmark} alt="" style={{ marginRight: '14px' }}></img>
              )}
              <p
                className="body2"
                style={{
                  margin: '0px',
                  color: 'var(--gray100)',
                  lineHeight: '150%',
                }}
              >
                {item.value}
              </p>
            </div>
          )
        }
      })}
      {seeAll &&
        value.map((item, index) => {
          if (index > 4) {
            return (
              <div
                style={{
                  display: 'flex',
                  marginBottom: '-1rem',
                  alignItems: 'baseline',

                  margin: '24px 0px',
                }}
              >
                {item.icon_name === 'checkmark' && (
                  <img
                    src={check_mark}
                    alt=""
                    style={{ marginRight: '14px' }}
                  ></img>
                )}
                {item.icon_name === 'xmark' && (
                  <img src={xmark} alt="" style={{ marginRight: '14px' }}></img>
                )}
                <p
                  className="body2"
                  style={{
                    margin: '0px',
                    color: 'var(--gray100)',
                    lineHeight: '150%',
                  }}
                >
                  {item.value}
                </p>
              </div>
            )
          }
        })}
      {value.length > 5 && (
        <div
          onClick={() => {
            showAll()
          }}
        >
          <ViewAll top={'24px'}>
            {!seeAll ? (
              <span>
                More<img src={downArrow} alt="down"></img>
              </span>
            ) : (
              <span>
                Less<img src={upArrow} alt="up"></img>
              </span>
            )}
          </ViewAll>
        </div>
      )}
    </div>
  )
}

export default CheckListLayout
